export default "__VITE_ASSET__3yEMwsh83MD1OJOoqk9INA__"